import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleArrowRight.svg",
  "use": "CircleArrowRight.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"CircleArrowRight.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56Zm0-44A20.0011,20.0011,0,0,0,12.1009,30H37.172l-7.5871-7.573a2.0016,2.0016,0,0,1,2.8324-2.8289L43.44,30.6024a1.9982,1.9982,0,0,1,0,2.829L32.4173,44.4359a2.0016,2.0016,0,0,1-2.8324-2.8291L37.206,34H12.1009A20,20,0,1,0,32,12Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol